(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dynamic-brands"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-brands-directory]').forEach((directory) => {
    const search = directory.querySelector('[data-brands-search]');
    const cards = Array.from(directory.querySelectorAll('[data-brand-card]'));
    const grid = directory.querySelector('[data-brands-grid]');
    const empty = directory.querySelector('[data-brands-empty]');
    const desktop = window.matchMedia('(hover: hover) and (pointer: fine)');

    const reserveOpenPanelSpace = () => {
      if (!desktop.matches || !grid) {
        directory.style.removeProperty('--open-panel-space');
        return;
      }

      const openCard = cards.find((card) => card.open && !card.hidden);
      const panel = openCard?.querySelector('.brands-directory__panel');

      if (!panel) {
        directory.style.removeProperty('--open-panel-space');
        return;
      }

      const overhang = Math.max(0, panel.getBoundingClientRect().bottom - grid.getBoundingClientRect().bottom);
      directory.style.setProperty('--open-panel-space', `${Math.ceil(overhang)}px`);
    };

    const closeCard = (card) => {
      if (!card.matches(':focus-within')) {
        card.open = false;
        reserveOpenPanelSpace();
      }
    };

    cards.forEach((card) => {
      card.addEventListener('mouseenter', () => {
        if (desktop.matches) {
          card.open = true;
          window.requestAnimationFrame(reserveOpenPanelSpace);
        }
      });
      card.addEventListener('mouseleave', () => {
        if (desktop.matches) closeCard(card);
      });
      card.addEventListener('focusin', () => {
        if (desktop.matches) {
          card.open = true;
          window.requestAnimationFrame(reserveOpenPanelSpace);
        }
      });
      card.addEventListener('focusout', () => {
        if (desktop.matches) window.requestAnimationFrame(() => closeCard(card));
      });
    });

    search?.addEventListener('input', () => {
      const query = search.value.trim().toLocaleLowerCase();
      let visible = 0;
      cards.forEach((card) => {
        const matches = !query || card.textContent.toLocaleLowerCase().includes(query);
        card.hidden = !matches;
        if (matches) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
      window.requestAnimationFrame(reserveOpenPanelSpace);
    });

    desktop.addEventListener('change', reserveOpenPanelSpace);
    window.addEventListener('resize', reserveOpenPanelSpace, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const media = window.matchMedia('(max-width: 959px)');

    const syncSection = section => {
      section.querySelectorAll('[data-product-tabs-shared-content]').forEach(content => {
        const blockId = content.dataset.productTabsSharedContent;
        const slotType = media.matches ? 'mobile' : 'desktop';
        const target = section.querySelector(`[data-product-tabs-${slotType}-slot="${CSS.escape(blockId)}"]`);

        if (target && content.parentElement !== target) {
          target.append(content);
        }
      });
    };

    const syncAll = () => {
      document.querySelectorAll('.product-tabs').forEach(syncSection);
    };

    syncAll();
    media.addEventListener('change', syncAll);
    document.addEventListener('shopify:section:load', syncAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
